// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63471d1f","732":"8fac68cd"}[chunkId] + ".chunk.js";
};